import { Component, OnInit } from '@angular/core';
import { DialogService } from 'ng2-bootstrap-modal';
import { AlertComponent } from 'app/popup/alert.component';
import { ErrorComponent } from 'app/popup/error.component';
import { VehicleMakeService } from 'app/services/vehicle-make.service';
import { UtilityServiceService } from 'app/services/utility-service.service';
import { error } from 'protractor';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-list-vehicle-make',
  templateUrl: './list-vehicle-make.component.html',
  styleUrls: ['./list-vehicle-make.component.css']
})
export class ListVehicleMakeComponent implements OnInit {

  vMakes: any = [];
  isRemove = false;
  removeRef: any;
  criteria = 'code';
  direction = false;
  page = 1;
  lblHeading = '';

  popoverTitle = 'Delete Vehicle Make';
  popoverMessage = 'Are you sure you want to delete Vehicle Make?';
  confirmText = 'Yes <i class="glyphicon glyphicon-ok"></i>';
  cancelText = 'No <i class="glyphicon glyphicon-remove"></i>';
  confirmClicked = false;
  cancelClicked = false;
  deleteConfirm = '';
  message = "Loading Vehicle Makes...";

  public isLoading = false;
  isEmpty: boolean = false;
  showNum: number = 10;

  constructor(private service: VehicleMakeService,
     public utility: UtilityServiceService,private toastr: ToastrService) { }

  ngOnInit() {
    this.onChangeHeandig();
    this.reload();
    this.utility.page = 1;
  }

  reload() {
    this.isLoading = true;
    this.service.getAll().subscribe(result => {
      this.vMakes = result;
      this.utility.onSort(1);
      //console.log(this.vMakes);
      this.isLoading = false;
    }, error => {
      console.dir(error);
      this.isLoading = false;
      this.isEmpty = true;
    });
  }

  onDelete(id: any) {
    this.service.delete(id).subscribe(result => {

      // this.dialogService.addDialog(AlertComponent, { title: 'Delete Vehicle Make', message: `Vehicle Make ${this.removeRef.code} deleted.`, bold: `${this.removeRef.code}` });
      this.toastr.success(`Vehicle Make ${this.removeRef.code} deleted.`,'Delete Vehicle Make');
      if (result != null) {
        this.onNo();
        this.reload();
      }
      this.onChangeHeandig();
    }, error => {
      error = error.json();
      // this.dialogService.addDialog(ErrorComponent, { title: 'Delete Vehicle Make', message: `Vehicle Make ${this.removeRef.code} was not deleted.`, statuscode: error.Status, url: error.Uri, servermessage: error.Message });
      this.toastr.success(`Vehicle Make ${this.removeRef.code} was not deleted.`,'Delete Vehicle Make');
    });
  }

  onSort() {
    this.direction = !this.direction;
  }

  onConfirm(doc: any) {
    this.removeRef = doc;
    this.deleteConfirm = `Are you sure you want to delete Vehicle Make <strong>${this.removeRef.code}</strong>?`;
    this.onChangeHeandig(false);
    this.isRemove = true;
  }

  onNo() {
    this.isRemove = false;
    this.onChangeHeandig();
  }

  onChangeHeandig(change: boolean = true) {
    this.lblHeading = (change) ? 'Vehicle Makes' : 'Delete Vehicle Make';
  }

  


}
